<lib-card>
  <ng-container title> Analisi dei gap</ng-container>
  <ng-container content>
    @if (score() !== undefined && score() !== null) {
      <div class="flex flex-row items-center pb-2 pt-4">
        <span
          class="flex items-baseline font-normal"
          [ngStyle]="{
            color:
              scoreQuality() === 'high'
                ? 'rgba(21, 128, 61)'
                : scoreQuality() === 'medium'
                  ? 'rgba(234, 179, 8)'
                  : 'rgba(185, 28, 28)',
          }"
        >
          <span class="text-4xl">{{ score() | number: '1.1-1' }}/</span>
          <span class="text-xl">{{ maxScore() | number: '1.0-0' }}</span>
        </span>
      </div>

      @if (showScoreBreakdown()) {
        <div
          class="mb-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-slate-600"
        >
          <span>
            <span class="font-semibold">Tecnica</span>
            {{ technicalScore() | number: '1.1-1' }} /
            {{ technicalMaxScore() | number: '1.0-0' }}
          </span>
          <span class="text-slate-400">+</span>
          <span>
            <span class="font-semibold">Economica</span>
            {{ economicScore() | number: '1.1-1' }} /
            {{ economicMaxScore() | number: '1.0-0' }}
          </span>
          <span class="text-slate-400">=</span>
          <span>
            <span class="font-semibold">Totale</span>
            {{ score() | number: '1.1-1' }} /
            {{ maxScore() | number: '1.0-0' }}
          </span>
        </div>
      }
    }

    @if (description()) {
      <p class="text-lg leading-relaxed text-slate-600">
        {{ description() }}
      </p>
    }
  </ng-container>
</lib-card>
